module.exports = __webpack_public_path__ + "img/at.823ba626.svg";